import agent, { prepareHeaders } from 'api/agent';
import { UpdateRestaurantDataModel } from 'api/models';

const PATH = '/Catalog';

export const Catalog = {
    /**
     * Apply a restaurant-specific override to a catalog (menu, section, dish, or ingredient).
     * Supports actions such as DisableEnable, ChangeAmount, and ChangeWorkArea via the provided data model.
     * @param restaurantId The target restaurant ID.
     * @param catalogId The catalog ID to override within the restaurant.
     * @param data Override descriptor containing target entity id, payload, data type, and action.
     */
    restaurantOverride(restaurantId: string, catalogId: string, data: UpdateRestaurantDataModel) {
        return agent.requests.put(
            `${PATH}/restaurant/${restaurantId}/catalog/${catalogId}`,
            data,
            prepareHeaders()
        );
    },
};
